import {
    GET_PROPERTY_TYPE_BREAKDOWN,
    GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS,
    GET_PROPERTY_TYPE_BREAKDOWN_FAILURE,
    GET_SECURITIES_STATUS_BREAKDOWN,
    GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS,
    GET_SECURITIES_STATUS_BREAKDOWN_FAILURE,
    GET_LOAN_STATUS_BREAKDOWN,
    GET_LOAN_STATUS_BREAKDOWN_SUCCESS,
    GET_LOAN_STATUS_BREAKDOWN_FAILURE,
    GET_CLOSING_DATE_BREAKDOWN,
    GET_CLOSING_DATE_BREAKDOWN_SUCCESS,
    GET_CLOSING_DATE_BREAKDOWN_FAILURE,
    GET_LOANS_SUMMARY,
    GET_LOANS_SUMMARY_SUCCESS,
    GET_LOANS_SUMMARY_FAILURE,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE,
    GET_DASHBOARD_SUMMARY_TOTALS,
    GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS,
    GET_DASHBOARD_SUMMARY_TOTALS_FAILURE,
} from './constants';

export const getPropertyTypeBreakdown = () => ({
    type: GET_PROPERTY_TYPE_BREAKDOWN,
    payload: {},
});

export const getPropertyTypeBreakdownSuccess = (data) => ({
    type: GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS,
    payload: data,
});

export const getPropertyTypeBreakdownFailure = (error) => ({
    type: GET_PROPERTY_TYPE_BREAKDOWN_FAILURE,
    payload: { message: error },
});

export const getSecuritiesStatusBreakdown = () => ({
    type: GET_SECURITIES_STATUS_BREAKDOWN,
    payload: {},
});
export const getSecuritiesStatusBreakdownSuccess = (data) => ({
    type: GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS,
    payload: data,
});
export const getSecuritiesStatusBreakdownFailure = (error) => ({
    type: GET_SECURITIES_STATUS_BREAKDOWN_FAILURE,
    payload: { message: error },
});

// Loan Status Breakdown
export const getLoanStatusBreakdown = () => ({
    type: GET_LOAN_STATUS_BREAKDOWN,
    payload: {},
});
export const getLoanStatusBreakdownSuccess = (data) => ({
    type: GET_LOAN_STATUS_BREAKDOWN_SUCCESS,
    payload: data,
});
export const getLoanStatusBreakdownFailure = (error) => ({
    type: GET_LOAN_STATUS_BREAKDOWN_FAILURE,
    payload: { message: error },
});

// Closing Date Breakdown
export const getClosingDateBreakdown = () => ({
    type: GET_CLOSING_DATE_BREAKDOWN,
    payload: {},
});
export const getClosingDateBreakdownSuccess = (data) => ({
    type: GET_CLOSING_DATE_BREAKDOWN_SUCCESS,
    payload: data,
});
export const getClosingDateBreakdownFailure = (error) => ({
    type: GET_CLOSING_DATE_BREAKDOWN_FAILURE,
    payload: { message: error },
});

// Loans Summary
export const getLoansSummary = () => ({
    type: GET_LOANS_SUMMARY,
    payload: {},
});
export const getLoansSummarySuccess = (data) => ({
    type: GET_LOANS_SUMMARY_SUCCESS,
    payload: data,
});
export const getLoansSummaryFailure = (error) => ({
    type: GET_LOANS_SUMMARY_FAILURE,
    payload: { message: error },
});

// Cashflow Per month breakdown
export const getCashflowPerMonthBreakdown = () => ({
    type: GET_CASHFLOW_PER_MONTH_BREAKDOWN,
    payload: {},
});
export const getCashflowPerMonthBreakdownSuccess = (data) => ({
    type: GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS,
    payload: data,
});
export const getCashflowPerMonthBreakdownFailure = (error) => ({
    type: GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE,
    payload: { message: error },
});

// Dashboard Summary Totals
export const getDashboardSummaryTotals = () => ({
    type: GET_DASHBOARD_SUMMARY_TOTALS,
    payload: {},
});
export const getDashboardSummaryTotalsSuccess = (data) => ({
    type: GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS,
    payload: data,
});
export const getDashboardSummaryTotalsFailure = (error) => ({
    type: GET_DASHBOARD_SUMMARY_TOTALS_FAILURE,
    payload: { message: error },
});